module.exports = __webpack_public_path__ + "img/occc.96811cb.svg";